import { Inject, Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { jwtDecode } from "jwt-decode";
import { AuthService } from './../../services/auth.service';
import { HomepageService } from "src/app/services/homepage.service";
import { DOCUMENT } from "@angular/common";
import { CookieService } from "ngx-cookie-service";
@Injectable({
  providedIn: "root",
})
export class JwtInterceptor implements HttpInterceptor {
  constructor(private route: Router, private authService: AuthService, private homepageService: HomepageService,@Inject(DOCUMENT) private document: Document,private cookieService: CookieService) {}
  refreshInProgress = false;
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let token = localStorage.getItem("token");
    let info = localStorage.getItem("info");
    let sessionId = localStorage.getItem("Session-Id") || "null";
    if(!((request.url.includes("/profile/me")) || (request.url.includes('/collectionitem/addtopersonal')) || (request.url.includes('/opacdirectory')))){
      if (token && info) {
        const decoded = jwtDecode(token);
        let systemDate = new Date();
        let expDate = new Date(decoded.exp * 1000);
        let timeDifference: any = expDate.getTime() - systemDate.getTime() ;
        const remainingSeconds = Math.floor(timeDifference / 1000);
        if (remainingSeconds < 60) { 
          this.authService.logoutSubject.next(true);
        }else if(remainingSeconds < 120){
          let refreshToken = localStorage.getItem("refreshToken");
          if(refreshToken  && !this.refreshInProgress){
            this.refreshInProgress = true;
            this.authService.refreshAccessToken(refreshToken).subscribe((refresh:any)=>{
              localStorage.setItem('token', refresh.access_token);
              localStorage.setItem('refreshToken', refresh.refresh_token);
              this.refreshInProgress = false;
              request = request.clone({
                setHeaders: {
                  Authorization: "Bearer " + token,
                  'Session-Id': sessionId,
                  'Page-Id': this.getPageId()
                },
              });
              return next.handle(request);
            },(errorRefresh)=>{
              this.authService.logoutSubject.next(true);
              this.refreshInProgress = false;
            });
          }
        }else{
          request = request.clone({
            setHeaders: {
              Authorization: "Bearer " + token,
              'Session-Id': sessionId,
              'Page-Id': this.getPageId()
            },
          });
        }
      }else{
        request = request.clone({
          setHeaders: {
            Authorization: 'null',
            'Session-Id': sessionId,
            'Page-Id': this.getPageId()
          },
        });
      }
      return next.handle(request);
    }
      return next.handle(request);
  }

  getPageId(){
    switch(true){
      case this.route.url === '/': return 'H';
      case this.route.url.includes('/explore'): return 'X';
      case this.route.url.includes('/new'): return 'N';
      case this.route.url.includes('/popular'): return 'P';
      case this.route.url.includes('/reading-lists'): return 'L';
      case this.route.url.includes('/news'): return 'W';
      case this.route.url.includes('/awards'): return 'A';
      case this.route.url.includes('/searchlist'): return 'R';
      case this.route.url.includes('/bulletins'): return 'B';
      case this.route.url.includes('/my-account'): return 'M';
      // case this.route.url.includes('/history'): return 'H';
      default: return 'H';
    }
    
   
  }
}
